import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import { Box } from "@material-ui/core";

export const stocksRenderer = (value, name, fieldUpdateHandler, isError) => {
    const addDetail = () => {
        if (!value) {
            fieldUpdateHandler(name, [{ text: "", color: "#000000" }]);
        } else {
            fieldUpdateHandler(name, [
                ...value,
                { text: "", color: "#000000" },
            ]);
        }
    };

    const updateDetail = (index, key, newValue) => {
        const newDetails = [...value];
        newDetails[index][key] = newValue;
        fieldUpdateHandler(name, newDetails);
    };

    const removeDetail = (index) => {
        const newDetails = value.filter((_, i) => i !== index);
        fieldUpdateHandler(name, newDetails);
    };

    return (
        <Box width={"45%"}>
            <div>
                {value?.length > 0 &&
                    value.map((detail, index) => (
                        <div key={index} style={{ marginBottom: "10px" }}>
                            <input
                                type="text"
                                value={detail.text}
                                onChange={(e) =>
                                    updateDetail(index, "text", e.target.value)
                                }
                                placeholder="Текст акции"
                                style={{
                                    marginRight: "10px",
                                    border: "none",
                                    borderRadius: "6px",
                                    outline: "none",
                                    padding: "4px 8px",
                                    color: "#FFFFFF",
                                    fontWeight: 700,
                                    fontSize: "12px",
                                    lineHeight: "16px",
                                    textAlign: "center",
                                    backgroundColor: value?.[index]?.color,
                                }}
                            />
                            <input
                                type="color"
                                value={detail.color}
                                onChange={(e) =>
                                    updateDetail(index, "color", e.target.value)
                                }
                                style={{
                                    marginRight: "10px",
                                    border: "none",
                                    backgroundColor: "#FFFFFF",
                                    outline: "none",
                                    cursor: "pointer",
                                }}
                            />
                            <button
                                style={{
                                    border: "none",
                                    outline: "none",
                                    backgroundColor: "#FFFFFF",
                                    cursor: "pointer",
                                }}
                                type="button"
                                onClick={() => removeDetail(index)}
                            >
                                ❌
                            </button>
                        </div>
                    ))}
                <button
                    style={{
                        scale: "2",
                        color: "green",
                        border: "none",
                        outline: "none",
                        backgroundColor: "#FFFFFF",
                        cursor: "pointer",
                    }}
                    type="button"
                    onClick={addDetail}
                >
                    +
                </button>
            </div>
            {!!isError && <TextField error={!!isError} helperText={isError} />}
        </Box>
    );
};
